export { default as OnBoarding } from './OnBoarding'
export { default as LoginAndSignup } from './LoginAndSignup'
export { default as ResetPassword } from './ResetPassword'
export { default as Dashboard } from './Dashboard'
export { default as Home } from './Home'
export { default as List } from './List'
export { default as Products } from './Products'
export { default as Meals } from './Meals'
export { default as SingleProduct } from './SingleProduct'
export { default as SingleList } from './SingleList'
export { default as OrderNow } from './OrderNow'
export { default as ProductScanning } from './ProductScanning'
export { default as ScanReceipt } from './ScanReceipt'
export { default as Blogs } from './Blogs'
export { default as UserProfile } from './UserProfile'
export { default as AboutUs } from './AboutUs'
export { default as PrivacyPolicy } from './PrivacyPolicy'
export { default as Feedback } from './Feedback'
export { default as NominateGrocery } from './NominateGrocery'
export { default as NominateBrand } from './NominateBrand'
export { default as SpreadWord } from './SpreadWord'
export { default as FAQs } from './FAQs'
export { default as OurTeam } from './OurTeam'
export { default as SingleFAQ } from './SingleFAQ'
export { default as EditProfile } from './EditProfile'
export { default as ChangePassword } from './ChangePassword'
export { default as ViewMore } from './ViewMore'
export { default as ViewMoreFiltered } from './ViewMoreFiltered'
export { default as Category } from './Category'
export { default as ProductType } from './ProductType'
export { default as BugAutomation } from './BugAutomation'
export { default as ViewUsers } from './ViewUsers'
export { default as ScanReceiptAutomation } from './ScanReceiptAutomation'
export { default as ViewPurchasedProducts } from './ViewPurchasedProducts'
export { default as AddPurchaseProducts } from './AddPurchaseProducts'
export { default as UpdatePurchaseProducts } from './UpdatePurchaseProducts'
export { default as RewardOption } from './RewardOption'
export { default as ViewUserRedemption } from './ViewUserRedemption'
export { default as AddNotification } from './AddNotification'
export { default as ViewNotifications } from './ViewNotifications'
export { default as ViewSingleNotifications } from './ViewSingleNotifications'
export { default as UserFeedback } from './UserFeedback'
export { default as AddRecallWarning } from './AddRecallWarning'
export { default as ViewRecallWarning } from './ViewRecallWarning'
export { default as ViewUpcCode } from './ViewUpcCode'
export { default as UpdateUpcCode } from './UpdateUpcCode'


// WEBPACK FOOTER //
// ./src/pages/index.js